import Vue from 'vue'
import { Route, RouteConfig } from 'vue-router'
import { RouteConfigSingleView, Position } from 'vue-router/types/router'
import { getTranslateValue } from '@/utils/util'
import getEnv from '@/utils/env'
const env = getEnv()
let mainPath = '/club'
if (env !== 'production') {
  mainPath = '/club-test'
}
interface RouteInterface {
  [index: string]: Array<RouteConfig>
}

interface RouteItem {
  path?: string,
  name?: string,
  module?: string,
  component?: Function,
  beforeEnter?: Function
}

const allRoutes: RouteInterface = {
  index: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "chunk-home" */'../views/Home.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        console.log('🌟home to, from', to, from)
        next()
      }
    },
    {
      path: '/task',
      name: 'task',
      component: () => import(/* webpackChunkName: "chunk-task" */'../views/Task.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('task_title') //'My Task'
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: '/mall',
      name: 'mall',
      component: () => import(/* webpackChunkName: "chunk-mall" */'../views/Mall.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('mall_title') //'M-Store'
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: '/history',
      name: 'history',
      component: () => import(/* webpackChunkName: "chunk-history" */'../views/History.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('mall_history_title') //'Exchange record'
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: '/textLive',
      name: 'textLive',
      component: () => import(/* webpackChunkName: "chunk-textlive" */'../views/TextLive.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('textlive_title') //'Text Broadcast'
        next()
      }
    },
    {
      path: '/showPic',
      name: 'showPic',
      component: () => import(/* webpackChunkName: "chunk-showpic" */'../views/ShowPic.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('textlive_pic_title') //'Picture details'
        next()
      }
    },
    {
      path: mainPath + '/detail',
      name: 'detail',
      component: () => import(/* webpackChunkName: "chunk-club-detail" */'../views/club/Detail.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('club_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: mainPath + '/race',
      name: 'race',
      component: () => import(/* webpackChunkName: "chunk-club-race" */'../views/club/Race.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('club_race_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: mainPath + '/create',
      name: 'create',
      component: () => import(/* webpackChunkName: "chunk-club-create" */'../views/club/Create.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('club_create_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: mainPath + '/auth',
      name: 'auth',
      component: () => import(/* webpackChunkName: "chunk-club-auth" */'../views/club/Auth.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('club_auth_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: mainPath + '/activity',
      name: 'activity',
      component: () => import(/* webpackChunkName: "chunk-club-activity" */'../views/club/Activity.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = 'PUBG Mobile Club Invitation Letter'; // getTranslateValue('club_auth_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: mainPath + '/testSavePic',
      name: 'testSavePic',
      component: () => import(/* webpackChunkName: "chunk-club-testactivity" */'../views/club/TestActivity.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = 'PUBG Mobile Club Invitation Letter'; // getTranslateValue('club_auth_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    // {
    //   path: mainPath + '/feed/detail',
    //   name: 'feed-detail',
    //   component: () => import(/* webpackChunkName: "chunk-feed-detail" */'../views/feed/Detail.vue'),
    //   beforeEnter (to: Route, from: Route, next: Function) {
    //     document.title = getTranslateValue('feed_title')
    //     console.log('🌟 to, from', to, from)
    //     next()
    //   }
    // },
    {
      path: mainPath + '/feed/review',
      name: 'review',
      component: () => import(/* webpackChunkName: "chunk-feed-review" */'../views/feed/Review.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('feeds_review_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: mainPath + '/feedback',
      name: 'feedback',
      component: () => import(/* webpackChunkName: "chunk-feedback" */'../views/feedback/Index.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('feedback_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: mainPath + '/jump',
      name: 'jump',
      component: () => import(/* webpackChunkName: "chunk-jump" */'../views/club/Jump.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('feedback_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: mainPath + '/rank',
      name: 'rank',
      component: () => import(/* webpackChunkName: "chunk-rank" */'../views/club/Rank.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('rank_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: mainPath + '/achievement',
      name: 'achievement',
      component: () => import(/* webpackChunkName: "chunk-achievement" */'../views/club/Achievement.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('achievement_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: mainPath + '/mediaAuth',
      name: 'mediaAuth',
      component: () => import(/* webpackChunkName: "chunk-media-auth" */'../views/club/MediaAuth.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('media_auth_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: mainPath + '/space',
      name: 'space',
      component: () => import(/* webpackChunkName: "chunk-space" */'../views/club/Space.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('space_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: mainPath + '/editorAuth',
      name: 'editorAuth',
      component: () => import(/* webpackChunkName: "chunk-editor-auth" */'../views/club/EditorAuth.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('editor_auth_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    {
      path: mainPath + '/guide',
      name: 'guide',
      component: () => import(/* webpackChunkName: "chunk-guide" */'../views/guide/Index.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        document.title = getTranslateValue('guide_title')
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    // {
    //   path: mainPath + '/topic/detail',
    //   name: 'topic-detail',
    //   component: () => import(/* webpackChunkName: "chunk-topic-detail" */'../views/topic/Detail.vue'),
    //   beforeEnter (to: Route, from: Route, next: Function) {
    //     document.title = getTranslateValue('topic_title')
    //     console.log('🌟 to, from', to, from)
    //     next()
    //   }
    // },
    // {
    //   // 兜底去首页
    //   path: '*',
    //   name: 'default',
    //   component: () => import(/* webpackChunkName: "chunk-home" */'../views/Home.vue'),
    //   async beforeEnter (to: Route, from: Route, next: Function) {
    //     document.title = 'Meemo'
    //     next()
    //   }
    // }
  ],
  task: [
    // {
    //   path: '/task',
    //   name: 'task',
    //   component: () => import('../views/Task.vue'),
    //   beforeEnter (to: Route, from: Route, next: Function) {
    //     document.title = '任务中心'
    //     console.log('🌟 to, from', to, from)
    //     next()
    //   }
    // }
  ],
  mall: [
    // {
    //   path: '/mall',
    //   name: 'mall',
    //   component: () => import('../views/Mall.vue'),
    //   beforeEnter (to: Route, from: Route, next: Function) {
    //     document.title = '商城'
    //     console.log('🌟 to, from', to, from)
    //     next()
    //   }
    // }
  ],
  history: [
    // {
    //   path: '/history',
    //   name: 'history',
    //   component: () => import('../views/History.vue'),
    //   beforeEnter (to: Route, from: Route, next: Function) {
    //     document.title = '积分历史'
    //     console.log('🌟 to, from', to, from)
    //     next()
    //   }
    // }
  ],
  club: [
    // {
    //   path: '/club/detail',
    //   name: 'detail',
    //   component: () => import('../views/club/Detail.vue'),
    //   beforeEnter (to: Route, from: Route, next: Function) {
    //     document.title = getTranslateValue('club_title')
    //     console.log('🌟 to, from', to, from)
    //     next()
    //   }
    // },
    // {
    //   path: '/club/race',
    //   name: 'race',
    //   component: () => import('../views/club/Race.vue'),
    //   beforeEnter (to: Route, from: Route, next: Function) {
    //     document.title = getTranslateValue('club_race_title')
    //     console.log('🌟 to, from', to, from)
    //     next()
    //   }
    // },
    // {
    //   path: '/club/create',
    //   name: 'create',
    //   component: () => import('../views/club/Create.vue'),
    //   beforeEnter (to: Route, from: Route, next: Function) {
    //     document.title = getTranslateValue('club_create_title')
    //     console.log('🌟 to, from', to, from)
    //     next()
    //   }
    // },
    // {
    //   path: '/club/auth',
    //   name: 'auth',
    //   component: () => import('../views/club/Auth.vue'),
    //   beforeEnter (to: Route, from: Route, next: Function) {
    //     document.title = getTranslateValue('club_auth_title')
    //     console.log('🌟 to, from', to, from)
    //     next()
    //   }
    // },
    // {
    //   path: '/club/activity',
    //   name: 'activity',
    //   component: () => import('../views/club/Activity.vue'),
    //   beforeEnter (to: Route, from: Route, next: Function) {
    //     // document.title = getTranslateValue('club_auth_title')
    //     console.log('🌟 to, from', to, from)
    //     next()
    //   }
    // },
    // {
    //   path: '/feed/detail',
    //   name: 'feed-detail',
    //   component: () => import('../views/feed/Detail.vue'),
    //   beforeEnter (to: Route, from: Route, next: Function) {
    //     document.title = getTranslateValue('feed_title')
    //     console.log('🌟 to, from', to, from)
    //     next()
    //   }
    // },
  ],
}

export default allRoutes


export const beforeEach = (currentModuleName: string) => {
  // 找到不是当前模块的所有path
  let otherModulePageNames: Array<object> = []
  for (const moduleName in allRoutes) {
    if (moduleName !== currentModuleName && allRoutes.hasOwnProperty(moduleName)) {
      const routes = allRoutes[moduleName]
      const pageNames = routes.map((item: RouteConfigSingleView) => {
        const includePageName = otherModulePageNames.find((eachOtherModule: RouteItem) => eachOtherModule.path === item.path)
        if (includePageName) {
          console.error('有重复页面：', item)
        }
        return {
          module: moduleName,
          path: item.path,
          name: item.name
        }
      })
      otherModulePageNames = otherModulePageNames.concat(pageNames)
    }
  }
  return async (to: Route, from: Route, next: Function) => {
    console.log('🌟 to, from', to, from)
    // 如果通过router.push 跳转的页面，不在当前模块里
    // 要通过location的方式跳转到对应的页面
    const otherModule: RouteItem | undefined  = otherModulePageNames.find((item: RouteItem) => item.path === to.path || item.name === to.name)
    if (otherModule) {
      const redirect = (href: string) => {
        if (from.name === null) {
          location.replace(href)
        } else {
          location.href = href
        }
      }
      let path = to.fullPath
      if (to.matched.length === 0 && to.fullPath === '/') {
        path = `${otherModule.path}`
      }
      const reg = new RegExp(`(${currentModuleName}\.(html)?\/?)$`)
      console.error(reg, location.pathname)
      if (reg.test(location.pathname)) {
        redirect(`${location.origin}${location.pathname.replace(reg, `${otherModule.module}.html`)}#${path}`)
      } else if (location.pathname.slice(-1) === '/') {
        redirect(`${location.origin}${location.pathname}${otherModule.module}.html#${path}`)
      } else {
        redirect(`${location.origin}${location.pathname}/${otherModule.module}.html#${path}`)
      }
      return
    }
    next()
  }
}

export const scrollBehavior = (to: Route, from: Route, savedPosition: void | Position) => {
  const needSavePaths = ['home']
  const toName = to.name as string
  const needSave = needSavePaths.indexOf(toName) !== -1
  if (savedPosition && needSave) {
    return savedPosition
  } else if (!needSave) {
    return { x: 0, y: 0 }
  }
}
